var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-title"}},[_c('v-layout',{attrs:{"wrap":"","row":""}},[_c('v-flex',{staticClass:"py-4",attrs:{"xs12":"","text-xs-center":""}},[_c('h2',{staticClass:"section-heading"},[_vm._v(_vm._s(_vm.title))]),_c('hr')])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }